import { Typography } from 'core/Typography';
import React from 'react';

import { ContentType } from '~/components/features/cases/RenessansBank/content-blocks';

export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Продукты',
        path: '/cases/products',
    },
];

export const listTitle = [
    {
        title: 'TalentMind — ИИ-платформа для скоринга софт-скилов',
        // eslint-disable-next-line max-len
        subtitle: `Разработали ИИ-платформу, которая анализирует аудио — и видеозаписи интервью HR-специалиста с кандидатом и оценивает 10 базовых софт-скилов. TalentMind в 9 раз сокращает время анализа интервью и на 80% ускоряет принятие решений. Его выводы на 87% совпадают с экспертной оценкой.`,
        description: [
            {
                name: 'Отрасль',
                details: 'HR',
            },
            {
                name: 'Услуги',
                details: 'ИИ-разработка',
            },
            {
                name: 'Сроки',
                details: 'июль 2025 по настоящее время',
            },
        ],
        company: 'TalentMind',
        companyLink: 'https://talentmind.ru/',
        companyLinkName: 'talentmind.ru',
        text: '',
    },
];

export const targetList = {
    title: 'Цель',
    description:
        // eslint-disable-next-line max-len
        'создать технологичный инструмент, который позволит компаниям любого масштаба объективно оценивать софт-скилы кандидатов по записям интервью.',
};

export const listChallenge: ContentType = {
    title: 'Контекст и вызов рынка',
    content: (
        <>
            <Typography variant="div">
                Неудачный найм дорого обходится бизнесу: компания теряет ресурсы на поиск, онбординг
                и обучение, а также время команды, вовлечённой в процесс. При этом последствия
                ошибки часто проявляются не сразу — спустя месяц может оказаться, что сотрудник не
                вписался в команду, не справился с темпом работы или потерял мотивацию.
            </Typography>
            <Typography variant="div">
                Существующие HR-инструменты в основном заточены под оценку хард-скилов. А «мягкие»
                навыки рекрутеры все ещё оценивают по собственному впечатлению от беседы. Такой
                подход повышает риск ошибок.
            </Typography>
        </>
    ),
};

export const listProblems: ContentType = {
    title: 'Сложности и вызовы',
    content: (
        <Typography variant="div">
            Оценка софтов — самая сложная и субъективная часть интервью. Команде предстояло научить
            систему понимать не только слова, но и контекст, эмоциональную окраску, структуру речи,
            смысл кейсов в разговоре кандидата. Благодаря применению передовых NLP-моделей
            и собственной системы промтов, TalentMind научился «слышать» больше, чем просто текст.
        </Typography>
    ),
};

export const listEvolution: ContentType = {
    title: 'Развитие продукта',
    content: (
        <>
            <Typography variant="div">
                Следующий этап развития Talent Mind — интеграция функции анализа эмоций
                и невербальных сигналов, а также возможность сравнения нескольких кандидатов на одну
                вакансию. Также появится возможность обогащения профиля кандидата по мере
                прохождения этапов собеседования.
            </Typography>
            <Typography variant="div">
                Talent Mind — это инструмент, который меняет парадигму оценки
                кандидатов.Он превращает субъективные интервью в источник данных, помогает бизнесу
                принимать решения осознанно и формировать сильные команды.
            </Typography>
        </>
    ),
};

export const listTeam = [
    {
        title: 'Команда',
        members: [
            {
                name: 'Александр Букуров ',
                position: 'Сооснователь продукта',
            },
            {
                name: 'Иван Поддубный',
                position: 'Сооснователь продукта',
            },
            {
                name: 'Никита Лантух',
                position: 'Менеджер продукта',
            },
            {
                name: 'Павел Воробьёв',
                position: 'Тимлид фронтенд-направления',
            },
            {
                name: 'Алина Нагабедян',
                position: 'HR-консультант',
            },
            {
                name: 'Дизайнер',
                position: '',
            },
            {
                name: '2 бэкенд-разработчика',
                position: '',
            },
        ],
    },
];
